import axios from 'axios';
import { component } from 'picoapp';

export default component((node, ctx) => {
  const input = node.querySelector('input');
  const button = node.querySelector('.button');
  const group = node.querySelector('.newsletter-inputs');
  const success = node.querySelector('.newsletter-success');

  const gate = document.querySelector('.js-password-protection');

  node.addEventListener('submit', e => {
    e.preventDefault();
    if (input.value === node.dataset.id) {
      gate.remove();
    } else {
      button.textContent = 'Incorrect Password';
      setTimeout(() => {
        button.textContent = 'Enter';
      }, 3000);
    }
  });
});
